import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ApiRequest from '../Common/restservice';
import { errorToast, successToast } from '../Common/showtoast';

function DocumentUpload() {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([]);
    const [document, setDocument] = useState("");
    const [description, setDescription] = useState("");
    const [title, setTitle] = useState("");
    useEffect(() => {
        GetTransactions();
    }, [])
    const GetTransactions = async () => {
        let res = await ApiRequest("documentreport.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        console.log(res);
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }
    const withdrawConfirm = async (json) => {
        let res = await ApiRequest("documentupload.asp", "POST", json, { Authorization: localStorage.getItem("token"), "Content-Type": "multipart/form-data" });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        successToast(res.message);
        // setWalletaddress("");
        setTitle("");
        setDescription("");
        setDocument("");
        GetTransactions();
    }
    return (
        <section className='content p-5'>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h3 className=" mt-3 mb-3 text-center">Upload Document</h3>
                            <div className="col-lg-12 row mt-2">
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Title</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="text" className=" form-control mt-2" placeholder="Please enter title" aria-label="Amount" tabIndex="1" value={title} onChange={(e) => {
                                        setTitle(e.target.value)
                                    }} />
                                </div>
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Short Description</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="text" className=" form-control mt-2" placeholder="Please enter description" aria-label="Amount" tabIndex="1" value={description} onChange={(e) => {
                                        setDescription(e.target.value)
                                    }} />
                                </div>
                                <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Document</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="file" className=" form-control mt-2" aria-label="Amount" tabIndex="1" onChange={(e) => {
                                        setDocument(e.target.files[0])
                                    }} />
                                </div>
                                {/* <label className="col-lg-6 col-md-12 col-form-label mt-2" type="button">Wallet Address (BEP20)</label>
                                <div className='col-lg-6 col-md-12' >
                                    <input type="text" className=" form-control mt-2" placeholder="Please enter bep20 wallet address" aria-label="Amount" tabIndex="1" value={walletaddress} onChange={(e) => {
                                        setWalletaddress(e.target.value)
                                    }} />
                                </div> */}
                            </div>
                            <div className="col-lg-12 col-md-12 text-center" >
                                <button className="btn btn-primary mt-5" onClick={async (e) => {
                                    // if (!walletaddress || Number(walletaddress)) {
                                    //     errorToast("Enter valid address");
                                    //     return;
                                    // } else 
                                    if (!title) {
                                        errorToast("Enter valid title");
                                        return;
                                    } else if (!description) {
                                        errorToast("Enter valid description");
                                        return;
                                    } else if (!document) {
                                        errorToast("Select valid document");
                                        return;
                                    }
                                    const formdata = new FormData();
                                    formdata.append("title", title);
                                    formdata.append("description", description);
                                    formdata.append("file", document);
                                    await withdrawConfirm(formdata)
                                }}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Document History</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="5">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.cdate}{item.ctime}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item.description}</td>
                                                        <td>
                                                            <a className="btn btn-primary" href={item.fileurl} target="_blank" rel="noopener noreferrer">
                                                                View
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default DocumentUpload
